<div class="shopee-container">
  <nz-spin [nzSpinning]="loading" class="shopee-spin">
    <div class="view-component-title">Atributos</div>

    <div class="attr-grid">
      <nz-card *ngFor="let attr of attribs; trackBy: trackByAttr"
               [class.cardred]="attr.mandatory" [class.cardnon]="!attr.mandatory">
        <div class="attr-card__header">
          <span class="attr-card__title" nz-tooltip [nzTooltipTitle]="getAttributeName(attr)">
            {{ getAttributeName(attr) }}
          </span>
          <span class="attr-card__id">{{ attr.attribute_id }}</span>
          <span *ngIf="!attr.mandatory" nz-icon nzType="close"
                class="attr-card__close" (click)="deleteItem(attr)"></span>
        </div>

        <shopee-attribute-field [attribute]="attr"></shopee-attribute-field>
      </nz-card>
    </div>

    <div class="actions">
      <button nz-button nzType="primary" (click)="okFunction()">Salvar</button>
      <button nz-button (click)="cancelFunction()">Cancelar</button>
    </div>
  </nz-spin>
</div>